import styled from 'styled-components';
import { Icon, Modal, PrimaryButton } from 'cosmos-components';

export const FormInsuranceContainer = styled.div`
    margin-bottom: 1.25rem;
`;

export const FormUpgradeContainer = styled.div`
    width: 90%;
    margin: auto;
    margin-top: 0.5rem;
`;

export const StyledModalPrimaryButton = styled(PrimaryButton)`
    position: relative;
    margin-left: auto;
    display: flex;
    opacity: 1;
    min-width: 5.6rem;
    align-items: center;
`;

export const Close = styled.div`
    text-align: left;
    letter-spacing: 0;
    color: ${({ theme: { colors } }) => colors.white};
    text-transform: capitalize;
    opacity: 1;
`;

export const StyledExitIcon = styled(Icon)`
    position: relative;
    margin-right: 0.5rem;
`;

export const StyledModal = styled(Modal)`
    .rc-dialog-content {
        border-top: ${({ theme: { colors } }) =>
            `0.4rem solid ${colors.secondaryOrange}`};
        color: ${({ theme }) => theme.colors.black};
        background: ${({ theme }) => theme.colors.white};
        overflow: auto;
    }
`;
